export default __webpack_public_path__ + "static/media/staff2.60137573.jpeg";